module.exports = __webpack_public_path__ + "assets/icons/ic_arrow_forward-aedc.svg";